import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as grpcWeb from 'grpc-web';

@Injectable({
  providedIn: 'root',
})
export class ConnectivityService {
  constructor(private router: Router) {
    /** */
  }

  /**
   * check server availability
   *
   * @param {grpcWeb.Error} err
   * @param {any} response
   * @returns {boolean} response
   */
  checkServerAvailability(err: grpcWeb.Error, response: any): boolean {
    /**
    if (err) {
      this.router.navigate(['/no-disponible']);
      return true;
    }
    */
    return false;
  }
}
